export default __webpack_public_path__ + "fe61152a21cf2623c5c5dcbd58630afb.png";